// File: noviopus-ats-client/src/features/OnBoardingFlow/onBoardingFlowSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OnboardingState } from './types'; // Import from types file

export const initialState: OnboardingState = {
  stage: 0,
  isCompleted: false,
  isLoading: false, 
  trackSteps: [],
  trackName: 'DEFAULT',
  redirectPath: null,
  initialRedirectComplete: false,
  completionMetrics: null, // Initialize
};

export const onBoardingFlowSlice = createSlice({
  name: 'onBoardingFlow',
  initialState,
  reducers: {
    setOnboardingStatus: (state, action: PayloadAction<Partial<OnboardingState>>) => {
      return { ...state, ...action.payload, isLoading: false };
    },
    checkOnboardingStatus: (state) => {
      state.isLoading = true;
    },
    onboardingCheckFailed: (state) => {
      state.isLoading = false;
      state.stage = 0;
      state.isCompleted = false;
    },
    setInitialRedirectComplete: (state) => {
      state.initialRedirectComplete = true;
      state.redirectPath = null;
    },
    advanceOnboardingStage: (state, action: PayloadAction<number | undefined>) => {
        state.isLoading = true; 
    },
    resetOnboardingState: () => initialState,
  },
});

export const { 
  setOnboardingStatus,
  checkOnboardingStatus,
  onboardingCheckFailed,
  setInitialRedirectComplete,
  advanceOnboardingStage,
  resetOnboardingState
} = onBoardingFlowSlice.actions;

export default onBoardingFlowSlice.reducer;